import { useRouterState } from '@tanstack/react-router';

import { cn } from '@/lib/utils';

/**
 * Keeps route feedback outside individual page layouts. The existing workspace
 * remains visually stable while lazy code and route data resolve.
 */
export function NavigationProgress() {
  const isPending = useRouterState({
    select: state => state.status === 'pending',
  });

  return (
    <div
      aria-hidden="true"
      data-testid="navigation-progress"
      className={cn(
        'pointer-events-none fixed inset-x-0 top-0 z-50 h-0.5 overflow-hidden transition-opacity duration-150',
        isPending ? 'opacity-100' : 'opacity-0',
      )}
    >
      <span className="navigation-progress-indicator block h-full w-2/5 rounded-full bg-primary" />
    </div>
  );
}
